import request from "@/utils/axios";

// export function getList() {
//   return request({
//     url: "/api/list",
//     method: "get",
//   });
// }
// 轮播图
export function getBannerList() {
  return request({
    url: "/Banner/getBannerList",
    method: "get",
  });
}
//公司简介
export function getCompanyIntroduce() {
  return request({
    url: "/CompanyIntroduce/getCompanyIntroduce",
    method: "get",
  });
}

//核心理念
export function getCoreConcept() {
  return request({
    url: "/CoreConcept/getCoreConcept",
    method: "get",
  });
}

//学习机
export function getLearningMachine() {
  return request({
    url: "/LearningMachine/getLearningMachine",
    method: "get",
  });
}

//系统
export function getMemorySystem() {
  return request({
    url: "/MemorySystem/getMemorySystem",
    method: "get",
  });
}

//书房
export function getStudyRoom() {
  return request({
    url: "/StudyRoom/getStudyRoom",
    method: "get",
  });
}

//团队风采
export function getTeamStyle() {
  return request({
    url: "/TeamStyle/getTeamStyle",
    method: "get",
  });
}

//荣誉展示
export function getHonorDisplay(data) {
  return request({
    url: "/HonorDisplay/getHonorDisplay",
    method: "get",
    data: data,
  });
}

//品牌介绍
export function getBrand() {
  return request({
    url: "/Brand/getBrand",
    method: "get",
  });
}

//团队风采-成就列表
export function getAchievement(data) {
  return request({
    url: "/TeamStyle/getAchievement",
    method: "post",
    data: data,
  });
}

//产品1哆念捻 AI 双语学习机 vs 传统学习机对比表
export function getComparisontable() {
  return request({
    url: "/Comparisontable/getComparisontable",
    method: "get",
  });
}

//产品2与传统学习机核心技术对比
export function getComparison() {
  return request({
    url: "/Comparison/getComparison",
    method: "get",
  });
}

//产品2与传统学习机用户价值差异对比
export function getDifferencesMachines() {
  return request({
    url: "/DifferencesMachines/getDifferencesMachines",
    method: "get",
  });
}

//产品3与传统书房的区别
export function getDifferencetraditional() {
  return request({
    url: "/Differencetraditional/getDifferencetraditional",
    method: "get",
  });
}

//公司最新动态
export function getNews(data) {
  return request({
    url: "/News/getNews",
    method: "post",
    data: data,
  });
}

//行内咨询
export function getIndustryInformation(data) {
  return request({
    url: "/IndustryInformation/getIndustryInformation",
    method: "post",
    data: data,
  });
}

//部分体验中心店
export function getExperiencecenter() {
  return request({
    url: "/Experiencecenter/getExperiencecenter",
    method: "get",
  });
}

//部分合作瞬间
export function getCollaborationMoment() {
  return request({
    url: "/CollaborationMoment/getCollaborationMoment",
    method: "get",
  });
}

//招贤纳士
export function getRecruitingTalents() {
  return request({
    url: "RecruitingTalents/getRecruitingTalents",
    method: "get",
  });
}

//获取经度纬度
export function getLongitude() {
  return request({
    url: "/RecruitingTalents/getLat",
    method: "get",
  });
}

//获取经度纬度
// export function getLatitude() {
//   return request({
//     url: "/RecruitingTalents/getLng",
//     method: "get",
//   });
// }

//获取电话
export function getPhone() {
  return request({
    url: "/RecruitingTalents/getPhone",
    method: "get",
  });
}

//获取邮箱
export function getEmail() {
  return request({
    url: "/RecruitingTalents/getEmail",
    method: "get",
  });
}

//获取地址
export function getAddress() {
  return request({
    url: "/RecruitingTalents/getAddress",
    method: "get",
  });
}

//获取备案
export function getBeian() {
  return request({
    url: "/RecruitingTalents/getBeian",
    method: "get",
  });
}

//获取二维码
export function getEwm() {
  return request({
    url: "/RecruitingTalents/getEwm",
    method: "get",
  });
}

//新闻详情
export function getNewsInfo(id,type) {
  return request({
    url: "/News/getNewsInfo",
    method: "post",
    data:{id,type}
  });
}

//获取底部信息
export function getFooterMsg() {
  return request({
    url: "/RecruitingTalents/getBqxx",
    method: "get",
  });
}

//获取轮播图
export function getProductList() {
  return request({
    url: "/ProductBanner/getBannerList",
    method: "get",
  });
}

//招商加盟
export function getZsjm() {
  return request({
    url: "/JoininVestment/getJoininVestment",
    method: "get",
  });
}

//加盟商全周期赋能体系
export function getJsfqz() {
  return request({
    url: "/Empowermentsystem/getBannerList",
    method: "get",
  });
}

//三大品牌产品
export function getThreemajorBrands() {
  return request({
    url: "/ThreemajorBrands/getThreemajorBrands",
    method: "get",
  });
}

//交付指导
export function getDeliveryGuide() {
  return request({
    url: "/DeliveryGuidance/getDeliveryGuidance",
    method: "get",
  });
}

//在线培训
export function getOnlineTraining() {
  return request({
    url: "/OnlineTraining/getOnlineTraining",
    method: "get",
  });
}

//seo标题
export function getSeoTitle() {
  return request({
    url: "/RecruitingTalents/getseotitle",
    method: "get",
  });
}

//发展历程
export function getDevelopmentHistory() {
  return request({
    url: "/CompanyIntroduce/getDevelopmenthistory",
    method: "get",
  });
}

//部分体验中心店视频
export function getPartialExperienceCenterVideo() {
  return request({
    url: "/Experiencecenter/getExperiencecentervideo",
    method: "get",
  });
}

//产品体验
export function getProductExperience() {
  return request({
    url: "/ProductBanner/getProductexperience",
    method: "get",
  });
}

//组织架构
export function getOrganizationStructure() {
  return request({
    url: "/RecruitingTalents/getOrganizational",
    method: "get",
  });
}

//记录
export function getRecord() {
  return request({
    url: "/RecruitingTalents/getPatent",
    method: "get",
  });
}